import { Charts } from './Charts';
import ConditionalityChartsDataProvider from './contexts/ConditionalityChartsDataContext';

const ConditionalityWrapper = () => {
    return (
        <ConditionalityChartsDataProvider>
            <Charts />
        </ConditionalityChartsDataProvider>
    );
};

export default ConditionalityWrapper;
